module.exports = __webpack_public_path__ + "static/media/icon-chat.2929b6b8.svg";